/* eslint-disable */
import React, { useEffect, useRef } from 'react';
import { useDataContext } from '../context';

const API_URL = import.meta.env.VITE_API_URL;

function GetAllCateFiles() { // เปลี่ยนชื่อจาก Token เป็น GetAllCateFiles
    const { data, setData } = useDataContext();
    
    // ตัวกันยิงซ้ำ
    const hasFetched = useRef(false);

    useEffect(() => {
      // 1. ถ้ามีข้อมูลแล้ว ไม่ต้องโหลด
      if (data.docType && data.docType.length > 0) {
          return;
      }

      // 2. กันยิงซ้ำ
      if (hasFetched.current) return;

      const fetchData = async () => {
        hasFetched.current = true;
        try {
          const myHeaders = new Headers();
          myHeaders.append("Authorization", "Basic SHJAYm9vbnNpcmkuY28udGg6SHJAYnNyISEh");
          
          const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow"
          };
          
          const response = await fetch(`${API_URL}/getAllCateFiles`, requestOptions);
          const result = await response.json();

          setData(prevData => ({
              ...prevData, 
              docType: result.resData || []
          }));

        } catch (error) {
          console.error("Error fetching file categories:", error);
          hasFetched.current = false;
        }
      };

      fetchData();
  
    }, []); // Run once on mount
    
  return null;
}

export default GetAllCateFiles;